export default __webpack_public_path__ + "db0738a73edd79a288a7b80dad0fba82.png";